module.exports = __webpack_public_path__ + "static/media/confettiMobile.d9a4b716.svg";